var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cities-block"},[(_vm.cities.length)?_c('div',{staticClass:"list-container"},_vm._l((_vm.cities),function(item){return _c('CityCard',{key:item.seo_entity_id,attrs:{"value":item}})}),1):_c('EmptyList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }